import { HTMLProps } from 'react';

import NavbarIcons from './NavbarIcons';

export interface NavbarIconsProps extends HTMLProps<HTMLDivElement> {
	setOpenPanel: (key: string) => void;
	openPanel: string;
}

export default NavbarIcons;